import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { noAuth: true }
  },
  {
    // 企微OAuth2回调落地页
    path: '/auth/wecom/callback',
    name: 'WecomCallback',
    component: () => import('@/views/WecomCallback.vue'),
    meta: { noAuth: true }
  },
  {
    // 批量附件导入（独立页面）
    path: '/batch-attachments',
    name: 'BatchAttachmentImport',
    component: () => import('@/views/BatchAttachmentImport.vue')
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/purchase',
    children: [
      {
        path: 'purchase',
        name: 'Purchase',
        component: () => import('@/views/Purchase.vue'),
        meta: { title: '研发采购' }
      },
      {
        path: 'usage',
        name: 'Usage',
        component: () => import('@/views/Usage.vue'),
        meta: { title: '研发领用' }
      },
      {
        path: 'accounting',
        name: 'Accounting',
        component: () => import('@/views/Accounting.vue'),
        meta: { title: '项目核算' }
      },
      {
        path: 'reimbursement',
        name: 'Reimbursement',
        component: () => import('@/views/Reimbursement.vue'),
        meta: { title: '报销统计' }
      },
      {
        path: 'attachment-export',
        name: 'AttachmentExport',
        component: () => import('@/views/AttachmentExport.vue'),
        meta: { title: '导出附件' }
      },
      {
        path: 'master',
        name: 'Master',
        component: () => import('@/views/Master.vue'),
        meta: { title: '数据库' }
      },
      {
        path: 'system/users',
        name: 'Users',
        component: () => import('@/views/Users.vue'),
        meta: { title: '用户管理', adminOnly: true }
      },
      {
        path: 'system/logs',
        name: 'OperationLog',
        component: () => import('@/views/OperationLog.vue'),
        meta: { title: '日志管理', adminOnly: true }
      }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.noAuth) {
    next()
    return
  }
  if (!token) {
    next('/login')
    return
  }
  if (to.meta.adminOnly) {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user.role !== 'admin') {
      next('/purchase')
      return
    }
  }
  next()
})

export default router
